<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        お問い合わせ
      </h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoC"
        class="dashboard-private-message">
        <div class="dashboard-private-message__heading">
          <h3 class="dashboard-private-message__title c-with-icon">
            <!-- eslint-disable max-len -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              shape-rendering="geometricPrecision"
              text-rendering="geometricPrecision"
              image-rendering="optimizeQuality"
              fill-rule="evenodd"
              clip-rule="evenodd"
              viewBox="0 0 511.999 463.377"
              class="icon-my_artist svg-icon">
              <path
                class="color1"
                d="M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203, 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821L216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z" /></svg>
            <!-- eslint-enable max-len -->
            サポート窓口からのお知らせ
          </h3>
        </div>
        <p class="dashboard-private-message__desc">
          ＜アーティストページや楽曲の紐付け修正について＞<br>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf172LGPQVEk74NAdmgTt6xq8MJo4B5WjZuinicjyoYteMwmg/viewform"
            class="c-text-link"
            target="_blank">【narasu】 アーティストページ修正受付フォーム</a>よりご依頼を承っております。
        </p>
        <p class="dashboard-private-message__desc">
          ＜YouTubeに関するお問い合わせについて＞<br>
          以下のお手続きに関しては、<a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdURkj1WpHkm8SWomZu_Hex0OPD9J2IF1zwFie3l9OP9CHIKg/viewform"
            class="c-text-link"
            target="_blank">【narasu】YouTubeお手続き受付フォーム</a>よりご依頼を承っております。
          <ul
            class="faq-result"
            style="margin:20px 0;">
            <li>ご自身の楽曲を利用したYouTube動画に対する、著作権侵害申し立ての取り下げ </li>
            <li>YouTubeのトピックチャンネル修正、新規作成</li>
            <li>YouTubeチャンネルの公式アーティストチャンネル化（OAC）</li>
          </ul>
          本問い合わせフォームではなく、お手続き受付フォームよりご連絡をお願いいたします。
        </p>
      </div>

      <contact-confirm
        v-if="showConfirmation"
        :form="form"
        :image="previewImage"
        @change-clicked="onChangeClicked"
        @send-clicked="onSendClicked">
      </contact-confirm>
      <div
        v-else
        class="profile-info">
        <form
          :class="{ 'form--error': errors }"
          @submit.prevent="submitForm">
          <div class="form-wrap form-wrap--profile u-no-margin-top">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="name">
                  お名前
                  <span class="req">＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="name"
                  v-model="form.name"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.name"
                  class="error-text">
                  {{ errors.name[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="email">
                  お客様のメールアドレス
                  <br class="pc">
                  （ご連絡先）
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="email"
                  v-model="form.email"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.email"
                  class="error-text">
                  {{ errors.email[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="type">
                  お問い合わせ内容
                  <span class="req">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      id="type"
                      v-model="form.type"
                      class="form-control c-select">
                      <option
                        value=""
                        disabled
                        selected
                        style="display:none;">
                        お問い合わせ内容を選択してください
                      </option>
                      <option
                        v-for="item in contact_types"
                        :key="item.value"
                        :value="item.text">
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.type"
                    class="error-text">
                    {{ errors.type[0] }}
                  </p>
                </div>
              </div>
            </div>

            <div
              v-if="form.type!=='配信停止について' && form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label form-label--top">
                <label
                  class="control-label"
                  for="subject">
                  件名
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="form-item">
                <div>
                  <input
                    id="subject"
                    v-model="form.subject"
                    class="form-control"
                    type="text"
                    @input="onChangeSubject">
                  <p
                    v-if="errors.subject"
                    class="error-text">
                    {{ errors.subject[0] }}
                  </p>
                </div>
                <div
                  v-if="faqs.length>0"
                  class="form-suggest-faqs">
                  <h3>下記のよくある質問もご参考ください</h3>
                  <ul class="faq-result">
                    <li
                      v-for="faq in faqs"
                      :key="`faq${faq.id}`">
                      <router-link
                        :to="{ name: 'faq-detail', params: { id: faq.id }}"
                        target="_blank"
                        class="c-text-link">
                        {{ faq.title }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="release_title">
                  <span v-if="form.type==='キャンペーン応募'">応募するリリースタイトル</span>
                  <span v-else>対象リリースタイトル</span>
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div
                class="form-item">
                <input
                  id="release_title"
                  v-model="form.release_title"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.release_title"
                  class="error-text">
                  {{ errors.release_title[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="artist_name">
                  <span v-if="form.type==='キャンペーン応募'">応募する対象アーティスト名</span>
                  <span v-else>対象アーティスト名</span>
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="artist_name"
                  v-model="form.artist_name"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.artist_name"
                  class="error-text">
                  {{ errors.artist_name[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="artist_name">
                  応募規約の同意
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <div class="checkbox">
                  <label>
                    <input
                      v-model="campaignAccept"
                      type="checkbox">
                    <div class="option-input"></div>
                    <a
                      href="/client/static/cam202204-01"
                      class="c-text-link"
                      target="_blank">応募規約</a>
                    に同意する
                  </label>
                </div>
                <p
                  v-if="errors.agree"
                  class="error-text">
                  {{ errors.agree[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' && isBtoC"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="release_id">
                  リリースID
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="release_id"
                  v-model="form.release_id"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.release_id"
                  class="error-text">
                  {{ errors.release_id[0] }}
                </p>
                ※リリースIDの確認方法は
                <router-link
                  :to="{ name: 'faq-detail', params: { id: 205 }}"
                  target="_blank"
                  class="c-text-link">
                  こちら
                </router-link>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' && !isBtoC"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="jan">
                  対象JANコード
                </label>
              </div>
              <div class="form-item">
                <input
                  id="jan"
                  v-model="form.jan"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.jan"
                  class="error-text">
                  {{ errors.jan[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label form-label--top">
                <label
                  class="control-label"
                  for="body">
                  <span v-if="form.type==='配信停止について'">配信停止理由</span>
                  <span v-else>お問い合わせ（内容の詳細）</span>
                  <span class="req">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <textarea
                  id="body"
                  v-model="form.body"
                  class="c-textarea">
                </textarea>
                <p class="form-item-text">
                  リリースタイトル・アーティスト名などは詳しくご入力ください。 <br>サポートチームができるだけ早く対応いたします。
                </p>
                <p
                  v-if="errors.body"
                  class="error-text">
                  {{ errors.body[0] }}
                </p>
              </div>
            </div>
            <div
              v-if="form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="body">
                  添付ファイル
                </label>
              </div>
              <div class="form-item">
                <a
                  v-if="!previewImage"
                  class="c-btn c-btn--download--narrow"
                  href="#"
                  @click.prevent="onUploadClicked">
                  ファイルをアップロード
                  <img
                    src="/img/common/icon-download_white.png"
                    alt="">
                </a>
                <p
                  v-if="!previewImage"
                  class="form-item-text">
                  より早く解決するためには、スクリーンショットを添付ファイルに追加してください。<br>
                  jpg/gif/png/tiffの画像ファイルのみアップロードできます。
                </p>
                <img
                  v-if="previewImage"
                  style="max-width: 320px"
                  :src="previewImage">

                <div class="delete-area">
                  <button
                    v-if="previewImage"
                    style="margin: 10px 0;"
                    type="button"
                    class="c-btn--delete"
                    @click.prevent="previewImage=''">
                  </button>
                </div>

                <p
                  v-for="(uploadError, index) in uploadErrors"
                  :key="index"
                  class="error-text">
                  {{ uploadError }}
                </p>
                <p
                  v-if="errors.image"
                  class="error-text">
                  {{ errors.image[0] }}
                </p>
                <input
                  ref="file"
                  type="file"
                  style="display:none"
                  accept="image/png,image/jpeg,image/gif,image/tiff"
                  @change="onFileChanged" />
              </div>
            </div>
          </div>
          <div class="consent-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="confirmed"
                  type="checkbox">
                <div class="option-input"></div>
                <router-link
                  link
                  :to="{ name: 'privacy' }"
                  class="c-text-link"
                  target="_blank">
                  個人情報保護方針
                </router-link>
                に同意して送信する
              </label>
            </div>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn"
              :class="{ 'c-btn--off' : !enableConfirmBtn }"
              @click.prevent="validate">
              内容を確認
              <span class="c-btn__icon-arrow">
              </span>
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lodash from 'lodash'
import base64ToBinary from '../../../logic/image'
import ContactConfirm from './Confirm'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Contact',
  components: { HeaderBar, ContactConfirm },
  data() {
    return {
      confirmed: false,
      campaignAccept: false,
      showConfirmation: false,
      form: {
        name: '',
        email: '',
        type: '',
        subject: '',
        body: '',
        release_title: '',
        artist_name: '',
        jany: '',
        image: '',
        requested_user_id: null,
      },
      contact_types: [
        { value: '1', text: 'サイトについて' },
        { value: '2', text: '楽曲について' },
        { value: '3', text: '配信について' },
        { value: '13', text: 'キャラクター使用許諾の申請' },
        { value: '4', text: 'アカウントについて' },
        { value: '6', text: 'アカウント復帰依頼' },
        { value: '7', text: 'ログインについて' },
        { value: '8', text: '配信停止について' },
        { value: '10', text: 'YouTube楽曲利用申請' },
        { value: '11', text: 'キャンペーン応募' },
        { value: '12', text: 'キャンペーンについて' },
        { value: '14', text: '著作権サービスについて' },
        { value: '15', text: 'スプリットについて' },
        { value: '9', text: 'その他' },
      ],
      errors: [],
      previewImage: null,
      uploadErrors: [],
      faqs: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    enableConfirmBtn() {
      if (this.form.type !== 'キャンペーン応募' && this.confirmed) {
        return true
      }
      if (this.form.type === 'キャンペーン応募' && this.confirmed && this.campaignAccept) {
        return true
      }
      return false
    },
  },
  mounted() {
    if (this.isBtoC) {
      // 「キャンペーン応募」はログイン時のみ表示(現在は一時的に非表示また復活予定)
      this.contact_types = this.contact_types.filter(type => type.value !== '10' && type.value !== '11')
    }
    if (this.isBtoB) {
      this.contact_types = this.contact_types.filter(type => type.value !== '11' && type.value !== '12')
    }
  },
  methods: {
    onChangeClicked() {
      window.scrollTo(0, 0)
      this.showConfirmation = false
    },
    async onSendClicked() {
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const formData = new FormData()
      const params = this.form
      params.confirmed = true
      if (this.isLoggedIn) {
        params.requested_user_id = this.$store.state.auth.id
      }
      if (this.previewImage && this.previewImage.indexOf('/') !== 0) {
        const base64String = this.previewImage.substr(this.previewImage.indexOf(',') + 1) // 先頭に制御文字があるので除去
        params.image = base64ToBinary(base64String)
      }
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key] !== null ? params[key] : '')
      })
      await window.axios.post('/api/client/contact', formData, config)
      this.$router.push({ name: 'contact-complete' })
    },
    async validate() {
      try {
        await window.axios.post('/api/client/contact', this.form)
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        window.scrollTo(0, 0)
        this.showConfirmation = response.status === 422
          && Object.keys(errors).length === 1
          && Object.prototype.hasOwnProperty.call(errors, 'confirmed')
      }
    },

    // ファイル選択ボタンクリック
    onUploadClicked() {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    // ファイル選択時コールバック
    onFileChanged(e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        this.checkImage(event.target.result)
      }
      reader.readAsDataURL(files[0])
    },
    // 画像のバリデーション
    async checkImage(base64image) {
      this.error = ''
      this.uploadErrors = []
      this.validated = false
      const base64String = base64image.substr(base64image.indexOf(',') + 1) // 先頭に制御文字があるので除去
      const formData = new FormData()
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      formData.append('image', base64ToBinary(base64String))

      const response = await window.axios.post('/api/client/image/validate/contact', formData, config)
      if (response.data.result) {
        this.previewImage = base64image
        this.validated = true
        delete this.errors.image
      } else {
        this.uploadErrors = response.data.messages
        this.validated = false
      }
    },
    async searchFaqs(keyword) {
      if (keyword) {
        const { data } = await window.axios.get(`/api/client/faqs/search/?keyword=${keyword}&page=1`, { headers: { 'X-CMAP-No-Loading': 1 } })
        this.faqs = data.data
      } else {
        this.faqs = []
      }
    },
    // eslint-disable-next-line func-names
    onChangeSubject: lodash.debounce(function (event) {
      this.searchFaqs(event.target.value)
    }, 500),
  },
}
</script>

<style scoped>
.form-suggest-faqs{
  margin-top:1em;
}
.form-suggest-faqs h3{
  border-bottom:1px solid #DEDEDE;
  margin-top:0.5em;
  margin-bottom:0.5em;
}
ul.faq-result{
  padding-left:1em;
}
.faq-result li{
  list-style-type:'・';
}
ul.faq-result li::marker{
  font-weight:normal;
}
</style>
